export const WITHOUT_LAYOUT = 'without'
export const MAIN_LAYOUT = 'main'
export const LIGHT_LAYOUT = 'light'
export const RESTRICTED_LAYOUT = 'restricted'
export const CHECKOUT_LAYOUT = 'checkout'
export const CUSTOMER_LAYOUT = 'customer'
export const CUSTOMER_CARE_LAYOUT = 'customer-care'
export const CUSTOMER_CARE_NO_SIDEBAR_LAYOUT = 'customer-care-no-sidebar'
export const GUEST_LAYOUT = 'guest'
export const SALES_AGENT_LAYOUT = 'sales-agent'
export const ERROR_LAYOUT = 'error'
